import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { Notification } from "../common/Notification";
import * as httpClient from "../../util/httpClient";
import * as TransactionActions from "../../store/transaction/actions";
import TransactionAlertPreferenceSection from "./TransactionAlertPreferenceSection";
import { useForm } from "react-hook-form";
import { isIDFPartnerUser } from "../../util/partner";
var summaryData: any[] = [];

const TransactionAlertPreferenceDialog = (props: any) => {
    const dispatch = useDispatch();
    const requestAccountSummary = () => dispatch(TransactionActions.actionCreators.requestAccountSummary());
    const [allAlertPreference, setAllAlertPreference] = useState(summaryData);
    const [duplicateRecordFound, setDuplicateRecordFound] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.partnerId &&
        state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    useEffect(() => {
        setIsLoading(true);
        requestAccountSummary();
        return () => {
            summaryData = [];
        };
    }, []);

    var settingTypes = ["purchase", "withdrawal", "deposit", "transfer", "uncategorized"];
    const prepareData = (alertPreference: []) => {
        var alertSettings: any[] = [];
        let id: number = 1;

        const foundPreference = alertPreference.find((it) => it["monitor-name"] === "Global" && it["setting-type"] === "duplicate");
        if (foundPreference) {
            setDuplicateRecordFound(foundPreference["active"] === "1");
        } else {
            setDuplicateRecordFound(false);
        }

        settingTypes.forEach(function (settingType) {
            //================================Set all Global Values ==================================================================//
            const foundPreference = alertPreference.find((it) => it["monitor-name"] === "Global" && it["setting-type"] === settingType);
            if (foundPreference != null) {
                alertSettings.push({
                    active: foundPreference["active"],
                    "alert-setting-id": foundPreference["setting-id"],
                    "monitor-id": foundPreference["monitor-id"],
                    type: settingType,
                    off: foundPreference["off"],
                    value: foundPreference["setting-value"],
                    "monitor-nickname": "Global",
                    "monitor-name": "Global",
                    id: id++,
                });
            } else {
                alertSettings.push({
                    active: "0",
                    "alert-setting-id": "-1",
                    "monitor-id": "0",
                    type: settingType,
                    value: "300.00",
                    off: 1,
                    "monitor-nickname": "Global",
                    "monitor-name": "Global",
                    id: id++,
                });
            }
            //================================Set all account values ==================================================================//
            const alertPrefs = alertPreference.filter((it) => it["monitor-name"] !== "Global" && it["setting-type"] === settingType);
            alertPrefs.forEach(function (alertPref) {
                alertSettings.push({
                    active: alertPref["active"],
                    "alert-setting-id": alertPref["setting-id"],
                    "monitor-id": alertPref["monitor-id"],
                    type: settingType,
                    off: alertPref["off"],
                    value: alertPref["setting-value"],
                    "monitor-nickname": alertPref["monitor-nickname"],
                    "monitor-name": alertPref["monitor-name"],
                    id: id++,
                });
            });
            //===================================== IF user does not have any pref setting value get value from summary data ===================//
            summaryData.forEach(function (summary) {
                const alertPrefs = alertPreference.find((it) => it["monitor-id"] === summary["idf-monitor-id"] && it["setting-type"] === settingType);
                if (alertPrefs == null) {
                    alertSettings.push({
                        active: "0",
                        "alert-setting-id": "-1",
                        "monitor-id": summary["idf-monitor-id"],
                        type: settingType,
                        value: "300.00",
                        off: 1,
                        "monitor-nickname": summary["account-name"],
                        "monitor-name": summary["account-nickname"],
                        id: id++,
                    });
                }
            });
        });
        setAllAlertPreference(alertSettings);
    };

    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const accountSummaryData = useSelector((state: ApplicationState) => {
        if (state.accountSummaryData == null || state.accountSummaryData.accountSummaryData == null) {
            return null;
        } else if (state.accountSummaryData.isLoading === false && state.accountSummaryData.accountSummaryData.data == null && isLoading === true) {
            setIsLoading(false);
            document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
        } else {
            if (state.accountSummaryData.accountSummaryData.data != null && summaryData.length !== state.accountSummaryData.accountSummaryData.data.length) {
                summaryData = state.accountSummaryData.accountSummaryData.data;
                httpClient
                    .sendRequest("GET", `api/financial-account/get-alert-preference`)
                    .then((data) => {
                        // eslint-disable-next-line eqeqeq
                        if (data["status-code"] == 200) {
                            // it comes as string or int inconsistantly.
                            var alertPreference = data.data || [];
                            prepareData(alertPreference);
                            setIsLoading(false);
                            document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
                        } else {
                            Notification({
                                type: "error",
                                title: "Get Alert Preference",
                                message: "Alert Preference get failed, please try again later.",
                                duration: 0,
                            });
                        }
                    })
                    .catch(function (error) {
                        Notification({
                            type: "error",
                            title: "Get Alert Preference",
                            message: "Alert Preference get failed, please try again later.",
                            duration: 0,
                        });
                    });
            }
        }
        return state.accountSummaryData.accountSummaryData;
    });

    useEffect(() => {
        const cancelBtn: any = document.getElementById("btn-cancel-transaction-set-alert-pref");
        if (cancelBtn != null) {
            cancelBtn.addEventListener("click", () => props.closeDialog("cancel"));
        }
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const setAlertPreference = () => {
        let submitArray: any[] = [];
        allAlertPreference.forEach(function (pref) {
            submitArray.push({
                "alert-setting-id": pref["alert-setting-id"],
                active: pref.active,
                value: parseFloat(pref.value),
                type: pref.type,
                "monitor-id": pref["monitor-id"],
            });
        });
        var request = { "alert-if-duplicate": duplicateRecordFound, "alert-settings": submitArray };

        httpClient
            .sendRequest("PUT", `api/financial-account/setAlertPreferences`, request)
            .then((data) => {
                Notification({
                    type: "success",
                    title: "Set Alert Preference",
                    message: "Alert preference set successful.",
                    duration: 5,
                });
                props.closeDialog("close");
            })
            .catch(function (error) {
                Notification({
                    type: "error",
                    title: "Set Alert Preference",
                    message: "Alert preference set failed, please try again later.",
                    duration: 0,
                });
            });
    };
    const handleduplicateTransAlert = (changeEvent: any) => {
        const isChecked = changeEvent.target.checked;
        setDuplicateRecordFound(isChecked);
    };
    const optionChanged = (optionName: string, checkedValue: string) => {
        var res = optionName.split("_");
        let newArr = [...allAlertPreference];
        if (res[2] === "all" || res[2] === "off") {
            newArr
                .filter((it) => it["monitor-name"] !== "Global" && it["type"] === res[0])
                .forEach(function (obj) {
                    obj.active = "0";
                });
        }

        newArr.forEach(function (obj) {
            if (obj.type === res[0] && obj["monitor-name"] === "Global") {
                if (res[2] === "off") {
                    obj.off = "1";
                    obj.active = "0";
                } else if (res[2] === "all") {
                    obj.off = "0";
                    obj.active = "1";
                } else {
                    obj.off = "0";
                    obj.active = "0";
                }
            } else if (obj.type === res[1] && obj["monitor-name"] !== "Global" && obj.id.toString() === res[2]) {
                obj.active = checkedValue;
            }
        });
        setAllAlertPreference(newArr);
    };
    const textChanged = (id: number, value: string) => {
        let newArr = [...allAlertPreference];
        newArr.forEach(function (obj) {
            if (obj.id === id) {
                obj.value = value;
            }
        });
        setAllAlertPreference(newArr);
    };
    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="las la-bell"></em>
                </div>
                <h1>Account Alert Preferences</h1>
            </div>
            {isLoading ? (
                <div className="box loading"></div>
            ) : (
                <React.Fragment>
                    {accountSummaryData != null && accountSummaryData.data == null ? (
                        <div className="box">
                            <div className="box-content text-align-center">
                                <div className="msg-generic">No accounts are currently being monitored.</div>
                                <div className="msg-generic">These can be added using the "Add Account" button.</div>
                            </div>
                        </div>
                    ) : (
                        <form id="form-transaction-alert-preference" onSubmit={handleSubmit(setAlertPreference)}>
                            <div className="dialog-body x-small-dialog-scroll">
                                <TransactionAlertPreferenceSection
                                    register={register}
                                    errors={errors}
                                    data={allAlertPreference.filter((it) => it["type"] === "purchase")}
                                    typeName={"PURCHASE"}
                                    textChanged={(id: number, value: string) => textChanged(id, value)}
                                    radioChanged={(optionName: string, checkedValue: string) => {
                                        optionChanged(optionName, checkedValue);
                                        window.addToDataLayer({ event: "Transaction Preference option changed to purchase." });
                                    }}
                                />
                                <TransactionAlertPreferenceSection
                                    register={register}
                                    errors={errors}
                                    data={allAlertPreference.filter((it) => it["type"] === "withdrawal")}
                                    typeName={"WITHDRAWAL"}
                                    textChanged={(id: number, value: string) => textChanged(id, value)}
                                    radioChanged={(optionName: string, checkedValue: string) => {
                                        optionChanged(optionName, checkedValue);
                                        window.addToDataLayer({ event: "Transaction Preference option Changed to withdrawal." });
                                    }}
                                />
                            {!isIDFPartner &&
                                    <TransactionAlertPreferenceSection
                                        register={register}
                                        errors={errors}
                                        data={allAlertPreference.filter((it) => it["type"] === "deposit")}
                                        typeName={"DEPOSIT"}
                                        textChanged={(id: number, value: string) => textChanged(id, value)}
                                        radioChanged={(optionName: string, checkedValue: string) => {
                                            optionChanged(optionName, checkedValue);
                                            window.addToDataLayer({ event: `Transaction Preference option changed to deposit.` });
                                        }}
                                    />
                             }
                                    <TransactionAlertPreferenceSection
                                        register={register}
                                        errors={errors}
                                        data={allAlertPreference.filter((it) => it["type"] === "transfer")}
                                        typeName={"TRANSFER"}
                                        textChanged={(id: number, value: string) => textChanged(id, value)}
                                        radioChanged={(optionName: string, checkedValue: string) => {
                                            optionChanged(optionName, checkedValue);
                                            window.addToDataLayer({ event: `Transaction Preference option changed to transfer.` });
                                        }}
                                    />                              
                                <TransactionAlertPreferenceSection
                                    register={register}
                                    errors={errors}
                                    data={allAlertPreference.filter((it) => it["type"] === "uncategorized")}
                                    typeName={"UNCATEGORIZED"}
                                    textChanged={(id: number, value: string) => textChanged(id, value)}
                                    radioChanged={(optionName: string, checkedValue: string) => {
                                        optionChanged(optionName, checkedValue);
                                        window.addToDataLayer({ event: "Transaction Preference option changed to uncategorized." });
                                    }}
                                />

                                {false && <div className="form-row no-margin">
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="duplicate-transaction-alert">
                                            <input
                                                type="checkbox"
                                                id="duplicate-transaction-alert"
                                                onChange={(e) => handleduplicateTransAlert(e)}
                                                name="duplicate-trans-alert"
                                                checked={duplicateRecordFound}
                                            />
                                            <span className="form-checkbox-label-text">Alert me if a duplicate transaction is detected</span>
                                        </label>
                                    </div>
                                </div>}
                            </div>

                            <div className="dialog-footer">
                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <button
                                            type="button"
                                            id="btn-cancel-transaction-set-alert-pref"
                                            onClick={() => {
                                                window.addToDataLayer({ event: "Cancel Setting Account Alert Preference" });
                                            }}
                                            className="btn-default btn-link btn-no-padding btn-no-border"
                                        >
                                            <span className="btn-text">Cancel</span>
                                        </button>
                                    </div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <button type="submit" className="btn-default btn-primary">
                                            <span className="btn-text">Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};
export default TransactionAlertPreferenceDialog;
